import { connect } from 'react-redux';
import en from '../../../../lang/en-us';
import { RootStateType } from '../../../../redux-store/reducers';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import SuccessScreen from '../SuccessScreen';
import { onLogout } from '../../../../redux-store/actions/login';
import { useEffect, useState } from 'react';
import { NoteModals } from '../../../../lib/NoteModals';
const { dashboard } = en;

function ChangeMobileSuccess(props: any) {
    const { mobile, reqId, isOffline = false } = props.location.state || {};
    const [showModal, setModal] = useState(false);
    useEffect(() => {
        !isOffline && !!props.mobile ? setModal(true) : setModal(false);
    }, []);

    const _handleModalClose = () => {
        if (!isOffline) {
            try {
                const { pan, pekrn, mobile: ExistingMobile } = props;
                const payload = {
                    pan: pan,
                    pekrn: pekrn,
                    mobile: ExistingMobile,
                };
                props.onLogout(payload);
            } catch (e: any) {
                console.log(e);
            }
        }
    };

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.ChangeMobile.Success.back}
                backLink="nct"
                info1={dashboard.ChangeMobile.Success.subHeadingInfo1}
                infospan1={maskMobileNumber(mobile)}
                info2={dashboard.ChangeMobile.Success.subHeadingInfo2}
                infospan2={reqId}
                info3={dashboard.ChangeMobile.Success.subHeadingInfo3}
                // list={getList(data)}
                backNavigation={() => props.history.goBack()}
                handleClick={() => props.history.push('/portal/track')}
            />
            <NoteModals
                showModal={showModal}
                heading={dashboard.Success.success}
                info={`${dashboard.Success.sucessMsg1} ${reqId}.${dashboard.Success.successMsg2}`}
                proceedBtn={'Okay'}
                onProceed={_handleModalClose}
            />
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    onLogout,
})(ChangeMobileSuccess);
